import React from 'react';

import i18n from '../../i18n';
import PropTypes from 'prop-types';
import styles from './SearchInputForm.module.scss';
import Icon from '../Icon';
import { useTranslation } from 'next-i18next';

const SearchInputForm = ({
    value = '',
    onChange = () => {},
    onSubmit = () => {},
    removeSearch = () => {},
}) => {
    const { t } = useTranslation();

    return (
        <form
            className={styles['SearchInputForm']}
            onSubmit={(e) => onSubmit(e)}>
            <input
                className={styles['SearchInputForm__Input']}
                value={value}
                placeholder={t('SearchInputForm.placeholder')}
                id="search_input"
                onChange={(e) => onChange(e.target.value)}
            />
            <span className={styles['SearchInputForm__ButtonWrapper']}>
                {value !== '' && (
                    <button
                        type="button"
                        onClick={removeSearch}
                        className={styles['SearchInputForm__Reset']}
                        aria-label={t('SearchInputForm.reset')}>
                        <Icon
                            type={'close'}
                            size={'small'}
                            color={'black800'}
                        />
                    </button>
                )}
                <button
                    className={styles['SearchInputForm__Button']}
                    aria-label={t('SearchInputForm.search')}
                    type="submit">
                    <span className={styles['SearchInputForm__ButtonText']}>
                        {t('SearchInputForm.search')}
                    </span>
                    <Icon type={'search'} size={'large'} />
                </button>
            </span>
        </form>
    );
};

SearchInputForm.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    removeSearch: PropTypes.func,
};

export default SearchInputForm;
